import { ReportRights } from "core/blueprint/trajectory/TrajectoryBlueprintService";

export function calculateRightStatus(
	rights: { [key: string]: boolean[] },
	selection: string[],
	rightsSize: number
): (boolean | undefined)[] {
	if (selection.length === 0) {
		return Array(rightsSize).fill(false);
	}

	const filtered = Object.entries(rights)
		.filter(value => selection.includes(value[0]))
		.map(value => value[1]);

	if (filtered.length === 0) {
		return Array(rightsSize).fill(false);
	}

	const summary = [];
	for (let rightIndex = 0; rightIndex < rightsSize; ++rightIndex) {
		const allowed = filtered.filter(r => r[rightIndex] === true).length;

		if (allowed === selection.length) {
			summary.push(true);
		} else if (allowed > 0 && allowed < selection.length) {
			summary.push(undefined);
		} else {
			summary.push(false);
		}
	}

	return summary;
}

export function calculateRoleRightStatus(
	rights: ReportRights,
	selection: string[],
	rightsSize: number
): (boolean | undefined)[] {
	if (selection.length === 0) {
		return Array(rightsSize).fill(false);
	}

	const filtered = Object.entries(rights)
		.filter(value => selection.includes(value[0]))
		.map(value => value[1])
		.map(value => value[""])
		.filter(value => value !== undefined);

	if (filtered.length === 0) {
		return Array(rightsSize).fill(false);
	}

	const summary = [];
	for (let rightIndex = 0; rightIndex < rightsSize; ++rightIndex) {
		const allowed = filtered.filter(r => r[rightIndex] === true).length;

		if (allowed === selection.length) {
			summary.push(true);
		} else if (allowed > 0 && allowed < selection.length) {
			summary.push(undefined);
		} else {
			summary.push(false);
		}
	}

	return summary;
}
